import { Link, useLocation } from 'react-router-dom';
import { Link as MuiLink, LinkProps, Box, Theme } from '@mui/material';
import { OverflowTooltip } from '@components/tooltip/OverflowTooltip';
import { adjustFontSize, adjustLineHeight } from '@theme/styleOverrides/typography';
import { ReactElement } from 'react';

interface ILink extends Omit<LinkProps, 'overflow'> {
  children?: ReactElement | string;
  label?: string;
  to: string;
  sx?: any;
  textOverflow?: string;
}

const gridStyles = {
  '&.MuiLink-root ': {
    color: 'secondary.main',
    fontFamily: 'Proxima Nova',
    fontWeight: 700,
    lineHeight: '1',
    '&:hover': {
      textUnderlineOffset: '4px',
    },

    '@media only screen and (max-width: 600px)': {
      fontSize: ({ palette }: Theme) => `${adjustFontSize(14, palette.fontSize)}px`,
      lineHeight: ({ palette }: Theme) => `${adjustLineHeight(20, palette.fontSize)}px`,
    },
  },
};

export const GridLink = ({ textOverflow, ...props }: ILink) => {
  const { children, label, to, sx } = props;

  const location = useLocation();

  const currentPathWithQuery = `${location.pathname}${location.search}`;

  return (
    <Box
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {textOverflow ? (
        <OverflowTooltip tooltipText={textOverflow}>
          <MuiLink
            {...props}
            sx={[gridStyles, sx]}
            underline='hover'
            component={Link}
            to={to}
            state={{ from: currentPathWithQuery }}
          >
            {label || children}
          </MuiLink>
        </OverflowTooltip>
      ) : (
        <MuiLink
          {...props}
          sx={[gridStyles, sx]}
          underline='hover'
          component={Link}
          to={to}
          state={{ from: currentPathWithQuery }}
        >
          {label || children}
        </MuiLink>
      )}
    </Box>
  );
};
